import {
  default as MuiDrawer,
  type DrawerProps as MuiDrawerProps,
  drawerClasses as muiDrawerClasses,
} from '@mui/material/Drawer';

/**
 * @deprecated Unsupported component: This component is not supported in the Unify design system.
 * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this component.
 */
export const Drawer = MuiDrawer;
/**
 * @deprecated Unsupported component: This component is not supported in the Unify design system.
 * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this component.
 */
export type DrawerProps = MuiDrawerProps;
/**
 * @deprecated Unsupported component: This component is not supported in the Unify design system.
 * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this component.
 */
export const drawerClasses = muiDrawerClasses;
